import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
  getPassbookDataRequest,
  getPassbookDataSuccess,
  getPassbookDataFailure,
} from "./passbookSlice";
import { toast } from "react-toastify";

function* fetchPassbookData(action) {
  try {
    const response = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/transactions/all`)
    );

    if (response.data.success) {
      yield put(getPassbookDataSuccess(response.data));
      toast.success("Passbook fetched successfully");
    } else {
      yield put(
        getPassbookDataFailure(response.data.message || "Failed to fetch passbook")
      );
      toast.error(response.data.message || "Failed to fetch passbook");
    }
  } catch (error) {
    yield put(getPassbookDataFailure(error.message));
    toast.error("Error fetching passbook");
  }
}


export function* passbookSaga() {
  yield takeLatest(getPassbookDataRequest.type, fetchPassbookData);
}
